import { z } from "zod";
import { defineRoute } from "./http/route.js";
/**
 * The one ingress for provider webhooks (docs/05-api-contracts.md section 13). The body is read raw so the
 * provider's signature can be checked over the exact bytes; processing happens later in the worker.
 */
export const receiveWebhook = defineRoute({
    id: "webhooks.receive",
    method: "POST",
    path: "/webhooks/{provider}",
    surface: "webhook",
    auth: "signature",
    permission: "none",
    marks: [],
    summary: "Receive a provider webhook: check its signature, store it once, and hand it to the worker; a duplicate is acknowledged and ignored",
    request: { params: z.object({ provider: z.string().regex(/^[a-z0-9-]{1,40}$/) }) },
    responses: {
        200: { description: "Stored, or already stored", schema: z.object({ received: z.literal(true) }) },
    },
    errors: ["AUTH_REQUIRED", "NOT_FOUND", "VALIDATION_FAILED"],
});
export const webhookRoutes = [receiveWebhook];
//# sourceMappingURL=webhook.routes.js.map